import { Component, Output, EventEmitter, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    templateUrl: './sys-work-flow-dialog.component.html'
})
export class SysWorkFlowDialogComponent extends AppComponentBase {
    @Output() onSave = new EventEmitter<any>();
    reason: string;
    title: string;
    saving = false;
    constructor(
        injector: Injector,
        public bsModalRef: BsModalRef
    ) {
        super(injector);
    }

    save(): void {
        if (this.reason === undefined) {
            this.saving = false;
        } else {
            this.saving = true;
            this.bsModalRef.hide();
            this.onSave.emit(this.reason);
            this.saving = false;
        }
    }
}
